import { render } from "./NoteSpese.vue?vue&type=template&id=537cf34f&scoped=true"
import script from "./NoteSpese.vue?vue&type=script&lang=js"
export * from "./NoteSpese.vue?vue&type=script&lang=js"

import "./NoteSpese.vue?vue&type=style&index=0&id=537cf34f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537cf34f"]])

export default __exports__